/*
* Story Theme
*
* Use this file to add custom Javascript to Story.  Keeping your custom
* Javascript in this fill will make it easier to update Story. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/

(function() {
  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.



  

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  var grid_item_elements = document.getElementsByClassName('product-grid-item');

  for (let i = 0; i < grid_item_elements.length; i++) {
    grid_item_elements[i].addEventListener("mouseover", function () {
      let image_fill = this.querySelectorAll('.image__fill')[0];
      let second_image = image_fill.dataset.second_image;
      let background_size_cover = image_fill.querySelectorAll('.background-size-cover')[0]

      // console.log(second_image);
      background_size_cover.style.backgroundImage = `url("${second_image}")`;
    });
    grid_item_elements[i].addEventListener("mouseout", function () {
        let image_fill = this.querySelectorAll('.image__fill')[0];
        let second_image = image_fill.dataset.main_image;
        let background_size_cover = image_fill.querySelectorAll('.background-size-cover')[0]

        // console.log(second_image);
        background_size_cover.style.backgroundImage = `url("${second_image}")`;
    });

  }
})();
